import apiActionsTypes from '../actions/api-action-types';

const initialState = {
  statesList: [],
  isLoading: false,
  error: null,
};

const statesReducer = (state = initialState, action) => {
  switch (action.type) {
    case apiActionsTypes.GET_STATES_DATA_START: {
      return { ...state, isLoading: true };
    }
    case apiActionsTypes.GET_STATES_DATA_SUCCESS: {
      const states = action.data?.data;
      return { ...state, statesList: states || [], isLoading: false };
    }
    case apiActionsTypes.GET_STATES_DATA_FAIL: {
      const error = action.data;
      // error.message
      // Network Error
      // Request failed with status code 404
      return { ...state, isLoading: false, error };
    }
    default:
      return state;
  }
};

export default statesReducer;
